import { GroupBase, StylesConfig } from 'react-select';
import { LocationOption } from './LocationSelect';

export const customSelectStyles: StylesConfig<LocationOption, false, GroupBase<LocationOption>> = {
  menu: (provided) => ({
    ...provided,
    overflow: 'hidden',
  }),
  option: (base, state) => {
    const { isFocused, isSelected } = state;
    let backgroundColor = 'white';
    if (isFocused) {
      backgroundColor = '#ffb5a5';
    } else if (isSelected) {
      backgroundColor = '#ff6251';
    }

    return {
      ...base,
      marginLeft: '1rem',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 'calc(100% - 1rem - 0.25rem)',
      marginRight: '0.25rem',
      backgroundColor,
      '&:hover': {
        backgroundColor: '#ff6251',
        color: 'white',
      },
    };
  },
  groupHeading: (base) => ({
    ...base,
    fontWeight: 'bold',
    paddingLeft: '10px',
  }),
};
